import { Stack, TextField } from '@mui/material';

export interface PeriodoFilterProps {
  dataInicio: string;
  dataFim: string;
  onChange: (next: { dataInicio: string; dataFim: string }) => void;
  disabled?: boolean;
}

export function PeriodoFilter({
  dataInicio,
  dataFim,
  onChange,
  disabled,
}: PeriodoFilterProps): JSX.Element {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        type="date"
        label="De"
        value={dataInicio}
        onChange={(e) => onChange({ dataInicio: e.target.value, dataFim })}
        InputLabelProps={{ shrink: true }}
        disabled={disabled}
        sx={{ minWidth: 180 }}
      />
      <TextField
        type="date"
        label="Até"
        value={dataFim}
        onChange={(e) => onChange({ dataInicio, dataFim: e.target.value })}
        InputLabelProps={{ shrink: true }}
        disabled={disabled}
        sx={{ minWidth: 180 }}
      />
    </Stack>
  );
}

export function defaultPeriodoMes(): { dataInicio: string; dataFim: string } {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const first = new Date(y, m, 1);
  const last = new Date(y, m + 1, 0);
  const fmt = (d: Date): string =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return { dataInicio: fmt(first), dataFim: fmt(last) };
}
